import { useEffect, useMemo } from 'react';

import { useGetDocumentRequestFile } from '@area-restrita/api-client/endpoints/document-request/document-request.gen';

export const useDocumentRequestFile = (documentRequestId: number) => {
  const { data, isLoading, error } =
    useGetDocumentRequestFile(documentRequestId);

  const { objectUrl, contentType, filename } = useMemo(() => {
    if (!data) return {};

    return {
      objectUrl: window.URL.createObjectURL(data),
      contentType: data.type,
      filename: extractFilenameFromBlob(data),
    };
  }, [data]);

  useEffect(() => {
    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  return {
    objectUrl,
    contentType,
    filename,
    isLoading,
    error,
  };
};

function extractFilenameFromBlob(blob: Blob): string | null {
  const contentDisposition = (blob as any).contentDisposition;
  if (!contentDisposition) return null;
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  return match ? match[1] : null;
}
